import { useEffect, useState } from "react"
import { useNavigate } from 'react-router-dom'
import { Button } from "@univdiam/ui/components/button"
import { CategoryDataTable } from "@univdiam/ui/customComponents/CategoryList/data-table"
import { categoryColumns } from "@univdiam/ui/customComponents/CategoryList/columns"
import { EditCategoryForm } from "@univdiam/ui/customComponents/CategoryList/EditCategoryForm"

import api from '@/http/api'

export default function CategoryPage() {
  const [data, setData] = useState([])
  const [editCategoryData, setEditCategoryData] = useState(null)

  useEffect(() => {
    api.get("/api/category")
    .then(res => {
      const transformed = res.data.data.map((category: any) => ({
        category_id: category.category_id.toString(),
        name: category.name,
        status: category.status === 1 ? "Enabled" : "Disabled"
      }))
      setData(transformed)
    })
    .catch(err => console.error("Failed to fetch categories", err))
  }, [])

  const handleDelete = async (id: string) => {
    console.log(id)
    const confirm = window.confirm("Are you sure you want to delete this category?")
    if (!confirm) return
  
    try {
      const res = await api.delete(`/api/category/${id}`)
      if (res.status === 200) {
        alert("Category deleted successfully.")
        // setData(prev => prev.filter(category => category.category_id !== id))
      } else {
        alert("Failed to delete category.")
      }
    } catch (error) {
      console.error("Delete error:", error)
      alert("Something went wrong.")
    }
  }

  const handleEdit = async (id: string) => {
    try {
      const res = await api.get(`/api/category/${id}`)
      if (res.status === 200) {
        setEditCategoryData(res.data)
        // setData(prev => prev.filter(category => category.category_id !== id))
      } else {
        alert("Failed to fetch category.")
      }
    } catch (error) {
      console.error("Delete error:", error)
      alert("Something went wrong.")
    }
  }

  const navigate = useNavigate()

  const handleAddCategory = () => {
    navigate("/category/add")
  }

  const columns = categoryColumns({ onEdit: handleEdit, onDelete: handleDelete })

  return (
    <div className="p-5">
      <div className="flex justify-between mb-4">
        <h1 className="text-xl font-semibold">Category Management</h1>
        {/* <Button onClick={() => setCreateCategory(true)}>+ Add Category</Button> */}
        <div className="flex justify-end mb-4">
        <Button onClick={handleAddCategory}>+ Add Category</Button>
    </div>
      </div>
      <CategoryDataTable columns={columns} data={data}/>
      {editCategoryData && (
        <EditCategoryForm
          user={editCategoryData}
          onCancel={() => setEditCategoryData(null)}
          onSave={() => {
            setEditCategoryData(null)
            // fetchCategories() // refresh table (commented out because it's undefined)
          }}
        />
      )}
    </div>
  )
}
